export const cartIcon = (
  <svg width="18" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.268 16.977c.432 0 .783-.419.783-.936 0-.517-.35-.936-.783-.936-.433 0-.784.42-.784.936 0 .517.35.936.784.936ZM13.927 16.977c.433 0 .784-.419.784-.936 0-.517-.351-.936-.784-.936-.433 0-.783.42-.783.936 0 .517.35.936.783.936Z"
      fill="#000"
    />
    <path d="m1 1.066 3.04 1.272L6.092 13.96h8.968" stroke="#000" />
    <path d="M4.496 4.563h12.138l-1.574 6.25-9.359.934" stroke="#000" />
  </svg>
);
